import * as React from "react";
import { ProductSizes } from "../../../../gobalType";

interface AvailabilitySectionProps {
  quantities?: Array<ProductSizes | any>;
  getMonthName: (id: number) => string;
  formatQuantityData: (amount: number) => string;
}

const AvailabilitySection = ({
  quantities = [],
  getMonthName,
  formatQuantityData,
}: AvailabilitySectionProps) => {
  return (
    <div className="available-detail">
      <span className=" title">Available:</span>

      <div className="quantity_available">
        {quantities?.map((value: any, index: number) => {
          const monthName = getMonthName(Number(value.month)) || "";
          const quantity = formatQuantityData(Number(value.quantity) || 0);
          return (
            <li key={index} className="content-detail">
              <span className="res-title month-detail">{monthName}: </span>
              <span className=" quanttity">{quantity}</span>
              <span>pcs</span>
            </li>
          );
        })}
      </div>
    </div>
  );
};

export default AvailabilitySection;
